import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { ANDROID_PLAY_STORE_URL, APP_REDIRECT_PATH, IOS_APP_STORE_URL } from '../utils/openInApp';

function Footer() {
    const isXL = useMediaQuery({ query: '(min-width: 1824px)' });
    const isLG = useMediaQuery({ query: '(min-width: 1224px)' }) && !isXL;
    const isMD = useMediaQuery({ query: '(min-width: 768px)' }) && !isLG && !isXL;
    const isSM = useMediaQuery({ query: '(min-width: 425px)' }) && !isMD && !isLG && !isXL;
    const isXS = useMediaQuery({ query: '(max-width: 425px)' });

    const { formatMessage } = useIntl();

    return (
        <div style={{
            padding: (isSM || isXS) ? "48px" : "48px 200px",
            backgroundColor: "#7001F6"
        }} >

            {/* <img src="/assets/images/footer-logo.svg" alt="footer logo" style={{ cursor: "pointer" }} onClick={() => window.location.href = "/"} /> */}

            <div
                style={{
                    display: "flex",
                    flexDirection: isXS ? "column" : "row",
                    flexWrap: (isXL || isLG) ? "nowrap" : "wrap",
                    gap: (isSM || isXS) ? "30px" : "90px",
                    alignItems: "center",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginTop: "36px",
                    justifyContent: "space-between",
                }}>
                {/* 
                <FooterItemWrapper>
                    <p style={{
                        fontWeight: "700",
                        margin: 0
                    }}>
                        <FormattedMessage id="owajoo_technology_inc" />
                    </p>
                    <FooterItem text="123 Street Name, City Name, Country Name" icon={<img src="/assets/images/location.png" alt="location" height={"24px"} width={"24px"} />} />
                    <FooterItem text={formatMessage({ id: "phone" }) + ": +123 456 7890"} icon={<img src="/assets/images/phone.png" alt="phone" height={"24px"} width={"24px"} />} />
                    <FooterItem text={formatMessage({ id: "email_address" }) + ": info@owajoo.com"} icon={<img src="/assets/images/email.png" alt="email" height={"24px"} width={"24px"} />} />
                </FooterItemWrapper> */}
                <div>
                    <FooterItemWrapper>
                        <FooterItem text={<FormattedMessage id='contact_us' />} link="/contact" />
                        <FooterItem text={<FormattedMessage id='about_us' />} link="/about-us" />
                        <FooterItem text={<FormattedMessage id='privacy_policy' />} link="/privacy-policy" />
                        <FooterItem text={<FormattedMessage id='user_agreement' />} link="/user-agreement" />
                    </FooterItemWrapper>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: isXS ? "column" : "row",
                    flexWrap: (isXL || isLG) ? "nowrap" : "wrap",
                    gap: (isSM || isXS) ? "30px" : "90px",
                    alignItems: (isSM || isXS) ? "center" : "end",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginTop: "36px",
                    justifyContent: "space-between",
                }}>
                    <div style={{
                        display: "flex",
                        gap: (isSM || isXS) ? "12px" : "16px",
                    }}>
                        <FooterItem link="https://www.instagram.com/owajoo/" icon={<img src="/assets/images/instagram.png" alt="instagram" height={"24px"} width={"24px"} />} />
                        <FooterItem link="https://www.facebook.com/owajoo" icon={<img src="/assets/images/facebook.png" alt="facebook" height={"24px"} width={"24px"} />} />
                        <FooterItem link={"https://x.com/owajoocom"} icon={<img src="/assets/images/x.png" alt="x" height={"24px"} width={"24px"} />} />
                        <FooterItem link={"https://www.tiktok.com/@owajoo.com"} icon={<img src="/assets/images/tiktok.png" alt="tiktok" height={"24px"} width={"24px"} />} />
                        <FooterItem link={"https://www.linkedin.com/company/owajoo/"} icon={<img src="/assets/images/linkedin.png" alt="linkedin" height={"20px"} width={"20px"} />} />
                        <FooterItem link={"https://www.youtube.com/@owajoo"} icon={<img src="/assets/images/youtube.png" alt="youtube" height={"24px"} width={"24px"} />} />
                    </div>
                    <FooterItemWrapper>
                        {/* QR https://owajoo.com/app adresini tasiyor; masaustunden tiklayanlar da ayni yere gitsin. */}
                        <a href={APP_REDIRECT_PATH} aria-label={formatMessage({ id: "download" })}>
                            <img src="/assets/images/qr.png" alt="qr" style={{ height: "116px", objectFit: "contain" }} />
                        </a>
                    </FooterItemWrapper>
                    <FooterItemWrapper>
                        <a href={IOS_APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="App Store">
                            <img src="/assets/images/app-store-badge.png" alt="app-store-badge" style={{ width: "165px", objectFit: "contain", cursor: "pointer" }} />
                        </a>
                        <a href={ANDROID_PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Google Play">
                            <img src="/assets/images/google-play-store-badge.png" alt="google-play-store-badge" style={{ width: "165px", height: "50px", objectFit: "contain", cursor: "pointer" }} />
                        </a>
                    </FooterItemWrapper>
                </div>
            </div>

        </div>
    )
}

function FooterItemWrapper({ children }) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px"
            }}
        >
            {children}
        </div>
    )
}

function FooterItem({ text, link, icon }) {
    const TextComponent = link ? Link : "p"
    return (
        <div style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            ...(link?.startsWith("http") ? { cursor: "pointer" } : {})
        }}
            onClick={() => {
                if (link?.startsWith("http")) {
                    window.open(link, "_blank")
                }
            }}
        >
            {!!icon && icon}
            <TextComponent {...(link ? {
                to: link,
                target: link?.startsWith("http") ? "_blank" : "",
                onClick: () => {
                    if (!(link?.startsWith("http"))) {
                        window.scrollTo(0, 0)
                    }
                }
            } : {})}
                style={{
                    margin: 0,
                    textDecoration: "none",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "500",
                }}
            >{text}</TextComponent>
        </div>
    )
}

export default Footer